'use client';

import { Product } from 'shared/types/product/Product';
import ProductDescription from 'components/padi-product/description';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';

export interface ProductDetailsTasticProps {
  title?: string;
  titleHtag?: string;
}

const ProductDetailsTastic = ({ data }: TasticProps<DataSource<{ product: Product }> & ProductDetailsTasticProps>) => {
  if (!data?.data?.dataSource?.product) return null;
  const { title, titleHtag } = data;
  return <ProductDescription product={data?.data?.dataSource.product} productDescriptionConfig={{ title, htag: titleHtag }} />;
};

export default ProductDetailsTastic;
